import { useState, useEffect, useCallback } from 'react'
import { getPrintSettings, updatePrintSettings } from '../services/api'

const STORAGE_KEYS = {
  printEnabled: 'printEnabled_browser',
  printerId: 'selectedPrinter_browser',
}

/**
 * Custom hook to manage print settings consistently
 * Uses localStorage as primary (browser-specific), API as sync target
 */
export function usePrintSettings() {
  const [printEnabled, setPrintEnabled] = useState(false)
  const [selectedPrinter, setSelectedPrinter] = useState('')
  const [loading, setLoading] = useState(true)

  // Load initial settings from localStorage only (browser-specific)
  useEffect(() => {
    // Always load from localStorage first (works without auth)
    const storedPrintEnabled = localStorage.getItem(STORAGE_KEYS.printEnabled)
    const storedPrinterId = localStorage.getItem(STORAGE_KEYS.printerId)
    setPrintEnabled(storedPrintEnabled === 'true')
    setSelectedPrinter(storedPrinterId || '')
    setLoading(false)
  }, [])

  // Update print settings
  const updateSettings = useCallback(async (enabled, printerId) => {
    // Always save to localStorage (browser-specific)
    localStorage.setItem(STORAGE_KEYS.printEnabled, enabled.toString())
    localStorage.setItem(STORAGE_KEYS.printerId, printerId || '')
    
    // Update local state
    setPrintEnabled(enabled)
    setSelectedPrinter(printerId || '')
    
    // Sync to API in background
    try {
      await updatePrintSettings({ enabled, printer_id: printerId || '' })
    } catch (error) {
      console.error('Error syncing print settings to API:', error)
      // LocalStorage is already saved, so settings are preserved
    }
  }, [])

  return {
    printEnabled,
    selectedPrinter,
    loading,
    updateSettings,
  }
}

export default usePrintSettings